import {
    handlePasskeyError,
    loginWithPasskey,
    passkeysSupported,
    registerPasskey,
} from './passkeys';
require('./bootstrap');
import { createApp } from 'vue'
import { i18n } from './i18n'
import ErrorModal from './components/ErrorModal.vue'
import TimeEntryCalendarWeek from './components/TimeEntryCalendarWeek.vue'

if (document.getElementById('app')) {
    const app = createApp()

    app.component('ErrorModal', ErrorModal)
    app.component('timeEntryCalendarWeek', TimeEntryCalendarWeek)

    app.use(i18n)

    app.mount('#app')
}

document.addEventListener('alpine:init', () => {
    Alpine.data('registerpasskey', (errorPrefix = null) => ({
        supported: passkeysSupported(),
        busy: false,
        error: null,
        name: '',

        async submit() {
            this.error = null;
            this.busy = true;

            try {
                await registerPasskey(this.name.trim());
            } catch (error) {
                this.error = handlePasskeyError(error, errorPrefix);
                this.busy = false;
            }
        },
    }));

    Alpine.data('loginform', (errorPrefix = null) => ({
        supported: passkeysSupported(),
        busy: false,
        error: null,

        async loginWithPasskey() {
            this.error = null;
            this.busy = true;

            try {
                await loginWithPasskey(this.$el.querySelector('input[name="remember"]')?.checked === true);
            } catch (error) {
                this.error = handlePasskeyError(error, errorPrefix);
                this.busy = false;
            }
        },
    }));
});
